<template>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{title}}</h4>
      </div>
      <div class="modal-body">{{msg}}</div>
      <div class="modal-footer">
        <button
          style="background-color: #f29911;border-color: #f29911;color:#fff"
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.back')}}</button>
        <button
          type="button"
          class="btn btn-primary btn-green"
          @click="onDelete"
        >{{$t('common.confirm')}}</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  props: {
    title: {
      type: String,
      default: () => { return "Xác Nhận" }
    },
    msg: {
      type: String,
      default: () => { return "Bạn Có Chắc ?" }
    },
    id: {
      type: Number,
      default: () => { return 0 }
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
    onDelete: function() {
      const id = this.id
      this.$emit("confirm", id)
    }
  },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Confirm.vue